import { render, staticRenderFns } from "./Nosubject.vue?vue&type=template&id=6b64e8b8&"
import script from "./Nosubject.vue?vue&type=script&lang=js&"
export * from "./Nosubject.vue?vue&type=script&lang=js&"
import style0 from "./Nosubject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports